import React, { Fragment, useContext, useState, useRef } from "react";
import { withRouter } from "react-router-dom";
import AlertContext from "../../context/alert/AlertContext";
import ConfigContext from "../../context/config/ConfigContext";
import PopupMessage from "./PopupMessage";
import DatePicker from "react-datepicker";
import useTokenCheck from "../../hooks/useTokenCheck";
import "react-datepicker/dist/react-datepicker.css";

const SearchMenu = (props) => {
  const alertContext = useContext(AlertContext);
  const { clearAlerts } = alertContext;
  const [search, setSearch] = useState({
    filterType: "",
    filterValue: "",
  });
  const configContext = useContext(ConfigContext);
  const { getConfigValueByCode } = configContext;
  const [enableInput, setEnableInput] = useState(false);
  const [error, setError] = useState({});
  const [showTooltip, setShowTooltip] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");
  const [fieldRef, setFieldRef] = useState(null);
  const [isFormValid, setIsFormValid] = useState(true);
  const filterValueRef = useRef(null);
  const fromPeriodRef = useRef(null);
  const toPeriodRef = useRef(null);
  //eslint-disable-next-line
  const [validationControl, setValidationControl] = useState({
    filterValue: filterValueRef,
    fromPeriod: fromPeriodRef,
    toPeriod: toPeriodRef,
  });
  const { filterType, filterValue, fromPeriod, toPeriod } = search;

  const { searchByList, includePeriod } = props;

  const Popup = (props) => {
    if (fieldRef) {
      return (
        <PopupMessage
          {...props}
          show={showTooltip}
          message={validationMessage}
          target={fieldRef}
        />
      );
    } else return "";
  };

  const requireInput = (input) => {
    return input === ""
      ? false
      : searchByList.filter((item) => {
          return item.name === input;
        })[0].requireInput;
  };

  const onChange = (e) => {
    if (e.target.name === "filterType") {
      const flag = requireInput(e.target.value);
      if (!flag) {
        setSearch({
          ...search,
          [e.target.name]: e.target.value,
          filterValue: "",
        });
        setEnableInput(flag);
      } else {
        setSearch({
          ...search,
          [e.target.name]: e.target.value,
        });
        setEnableInput(flag);
        // if (e.target.value === "")
        //   setError({
        //     [e.target.name]: `Please enter value for ${e.target.name}`,
        //   });
      }
    } else {
      // if (includePeriod && e.target.name === "toPeriod") {
      //   if (e.target.value < fromPeriod) {
      //     setError(`To Date must be older than From Date`);
      //   }
      // }
      setSearch({
        ...search,
        [e.target.name]: e.target.value,
      });
    }
    checkFormIsValid(e.target.name, e.target.value);
  };
  const { hasTokenExpired } = useTokenCheck();
  const onSubmit = async (e) => {
    await hasTokenExpired();
    e.preventDefault();
    console.log("OnSubmit - Search");
    props.onSearch(search);
  };

  const checkFormIsValid = (fieldName, fieldValue) => {
    clearAlerts();
    const start = fieldName === "fromPeriod" ? fieldValue : fromPeriod;
    const end = fieldName === "toPeriod" ? fieldValue : toPeriod;

    console.log("Start ", start);
    console.log("End", end);
    if (start && end && start > end) {
      setError({ toPeriod: `To Date must be older than From Date` });
      setIsFormValid(false);
      validateField(null, "toDate");
      return;
    } else {
      setError({
        toPeriod: "",
      });
    }

    console.log("Field ", fieldName);
    console.log("Field value", fieldValue);
    console.log("Field ", filterType);
    console.log("Field value", filterValue);
    if (fieldName === "filterType" && !fieldValue) {
      console.log("Skipping Default");
      setIsFormValid(true);
      return true;
    }
    const missingField = searchByList.filter((item) => {
      return (
        item.requireInput &&
        ((fieldValue === item.name && filterValue === "") ||
          (filterType === item.name && fieldValue === ""))
      );
    });
    if (missingField.length > 0) {
      let res = getConfigValueByCode("generalConfig", "RESPONSE_MSG", 479);
      res = res.replace("{0}", missingField[0].displayName);
      setError({ filterValue: res });
      setIsFormValid(false);
      return;
    } else {
      setError({
        filterValue: "",
      });
    }
    setIsFormValid(true);
  };

  const validateField = (e, fieldName) => {
    console.log("validation for :", e);
    fieldName = fieldName ? fieldName : e.target.name;
    console.log("Error:", error[fieldName]);
    if (error[fieldName] !== undefined && error[fieldName] !== "") {
      // clearAlerts();
      // setAlert(error[e.target.name], "danger");
      setValidationMessage(error[fieldName]);
      console.log("Error for:", fieldName);
      console.log("Error:", error);
      setFieldRef(validationControl["filterValue"]);
      console.log("CTRL:", validationControl[fieldName]);
      console.log("CTRL:", validationControl["filterValue"]);
      const intervalID = setInterval(setShowTooltip(true), 5000);
      setTimeout(() => {
        setShowTooltip(false);
        clearInterval(intervalID);
      }, 5000);
    }
  };
  // console.log("###Serach List: ", searchByList);
  // console.log("###Period flag: ", includePeriod);
  return (
    <Fragment>
      <Popup role="alert" aria-relevant="all" />
      <div id="search" className="search" role="search">
        <form className="search__formBody">
          <div
            className={
              includePeriod
                ? "search__formBody__formGroup__includePeriod"
                : "search__formBody__formGroup"
            }
          >
            <div className="search__formBody__formGroup__searchBy">
              <div className="search__formBody__formContainer">
                <label htmlFor="filterType">Select By</label>
                <select
                  name="filterType"
                  id="filterType"
                  className="address__formBody__formGroup__stateList"
                  onChange={onChange}
                  value={filterType}
                >
                  <option value="">--Select--</option>
                  {searchByList &&
                    searchByList.map((item, index) => (
                      <option key={index} value={item.name}>
                        {item.displayName}
                      </option>
                    ))}
                </select>
              </div>
              <div className="search__formBody__formContainer">
                <label htmlFor="filterValue">Select Value</label>
                <input
                  type="text"
                  name="filterValue"
                  id="filterValue"
                  className="form-control"
                  onChange={onChange}
                  value={filterValue}
                  disabled={!enableInput}
                  onBlur={validateField}
                  ref={filterValueRef}
                />
              </div>
            </div>
            <div className="search__formBody__formGroup__searchAction">
              {includePeriod && (
                <Fragment>
                  <div className="search__formBody__formContainer">
                    <label htmlFor="fromDate">From</label>
                    <DatePicker
                      name="fromDate"
                      id="fromDate"
                      selected={fromPeriod}
                      onChange={(date) => {
                        if (date === null) {
                          date = undefined;
                        }
                        setSearch({ ...search, fromPeriod: date });
                        checkFormIsValid("fromPeriod", date);
                      }}
                      placeholderText="mm/dd/yyyy"
                      onBlur={(e) => validateField(e, "fromPeriod")}
                      ref={fromPeriodRef}
                    />
                  </div>
                  <div className="search__formBody__formContainer">
                    <label htmlFor="toDate">To</label>
                    <DatePicker
                      name="toDate"
                      id="toDate"
                      selected={toPeriod}
                      onChange={(date) => {
                        if (date === null) {
                          date = undefined;
                        }
                        setSearch({ ...search, toPeriod: date });
                        checkFormIsValid("toPeriod", date);
                        validateField(null, "toPeriod");
                      }}
                      placeholderText="mm/dd/yyyy"
                      onBlur={(e) => validateField(e, "toPeriod")}
                      ref={toPeriodRef}
                    />
                  </div>
                </Fragment>
              )}
              <input
                type="submit"
                name="search"
                className="btn btn-primary form-control"
                value="Search"
                onClick={onSubmit}
                disabled={!isFormValid}
                aria-label="Search "
              />
            </div>
          </div>
        </form>
      </div>
    </Fragment>
  );
};

export default withRouter(SearchMenu);
